/* global firebase */
import { useState, useEffect } from 'react';
import tagTemplates from 'config/tags.js';

export function useTags(companyId) {
  let [data, setData] = useState(null);
  
  useEffect(() => {
    if(!companyId) {
      setData(null);
      return;
    }
    
    return firebase.firestore()
      .collection('companies')
      .doc(companyId)
      .collection('tags')
      .orderBy("dateModified", "desc")
      .onSnapshot(querySnapshot => {
        const newData = [];
        querySnapshot.forEach(function(doc) {
          newData.push({
            id: doc.id,
            ...doc.data()
          });
        });
        setData(newData);
      });
  }, [companyId]);
  
  return data;
}

export function useUnassignedTags(companyId) {
  let [data, setData] = useState(null);
  
  useEffect(() => {
    if(!companyId) {
      setData(null);
      return;
    }
    
    return firebase.firestore()
      .collection('companies')
      .doc(companyId)
      .collection('tags')
      .where('campaignId', "==", "NONE")
      .orderBy("dateModified", "desc")
      .onSnapshot(querySnapshot => {
        const newData = [];
        querySnapshot.forEach(function(doc) {
          newData.push({
            id: doc.id,
            ...doc.data()
          });
        });
        setData(newData);
      });
  }, [companyId]);
  
  return data;
}

export function useCampaignTags(companyId, campaignId) {
  let [data, setData] = useState(null);
  
  useEffect(() => {
    if(!companyId) {
      setData(null);
      return;
    }
    
    return firebase.firestore()
      .collection('companies')
      .doc(companyId)
      .collection('tags')
      .where('campaignId', "==", campaignId)
      .onSnapshot(querySnapshot => {
        const newData = [];
        querySnapshot.forEach(function(doc) {
          newData.push({
            id: doc.id,
            ...doc.data()
          });
        });
        setData(newData);
      });
  }, [companyId, campaignId]);
  
  return data;
}

export function useTag(companyId, tagId) {
  let [data, setData] = useState(null);
  
  useEffect(() => {
    if(!companyId || !tagId) {
      setData(null);
      return;
    }
    return firebase.firestore()
      .collection('companies')
      .doc(companyId)
      .collection('tags')
      .doc(tagId)
      .onSnapshot(doc => {
        if(!doc.exists) {
          return;
        }
        setData({
          id: tagId,
          ...doc.data(),
        });
      });
  }, [companyId, tagId]);
  
  return data;
}

export function useTagProducts(tier) {
  const [data, setData] = useState(null);
  
  useEffect(() => {
    if(!tier) {
      setData(null);
      return;
    }
  
    firebase.functions().httpsCallable('loadShopifyProducts')({tier}).then(res => {
      setData(res.data);
    });
  
      
  }, [tier]);
  
  return data;
}

export async function createTag(companyId, data={}) {
  if(!companyId) {
    return;
  }
  
  const variantId = data.variant && data.variant.id;
  let template = variantId ? tagTemplates[variantId] : {};
  
  const ref = await firebase.firestore()
    .collection('companies').doc(companyId)
    .collection('tags')
    .add({
      dateCreated: Date.now(),
      campaignId: "NONE",
      ...template,
      ...data,
    });
    
  return ref.get().then(snap => ({id:ref.id, ...snap.data()}));
}

export async function updateTag(companyId, tagId, update={}) {
  if(!companyId || !tagId) {
    return;
  }
  
  if(update.variant) {
    update = {
      ...tagTemplates[update.variant.id],
      ...update, 
    };
  }
  
  return firebase.firestore()
    .collection('companies').doc(companyId)
    .collection('tags').doc(tagId)
    .update({
      dateModified: Date.now(),
      ...update
    });
}

export async function orderTag(companyId, tagId, quantity) {
  const res = await firebase.functions().httpsCallable('createShopifyCheckout')({
    companyId,
    tagId,
    quantity,
  });
  return res.data;
}

export async function refreshTagPreview(companyId, tagId) {
  try {
    const res = await firebase.functions().httpsCallable('refreshTagPreview')({companyId, tagId});
    return res.data;
  }
  catch(error) {
    console.log('refresh tag preview error', error);
  }
}